import React from 'react';
import Gallery from '../components/Gallery/Gallery';

const GalleryPage: React.FC = () => {
  return (
    <main className="page">
      <Gallery />
    </main>
  );
};

export default GalleryPage; 